import React from "react";
import Navigation from "../components/Navigation";
import { useTranslation } from "react-i18next";
import KeyImage from "../assets/images/key.png";
const ForgotPin = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Navigation title={t("FORGOT_PIN")} appBarColor="orange" />
      <div className="fixed-layout flex flex-col  ">
        <div className="white-card my-2 flex flex-1 justify-center items-center">
          <div className="w-10/12 mx-auto text-center font-light text-lg">
            <img src={KeyImage} alt="forgot" className="w-[30%] mx-auto mb-5" />

            <p className="mb-0 text-lg font-bold">Contact us on </p>

            <p className="py-1 text-lg">
              <a href="tel:7905209748" className=" text-secondary font-light">
                7905209748
              </a>
            </p>

            <p className="mb-0 text-base text-center text-gray-500">
              If you have forgotten your Pin
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPin;
